import { render } from "./App.vue?vue&type=template&id=6cee8af8"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./assets/css/style.css?vue&type=style&index=0&lang=css"
import "./App.vue?vue&type=style&index=1&id=6cee8af8&lang=scss"

import exportComponent from "F:\\PWAs\\riva-pwa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__